import React, { Component } from "react";
import SentenceTrendsEditButton from "./SentenceTrendsEditButton";

/** Remove legacy embedded benefit rows from statement HTML. */
function stripEmbeddedBenefitParagraph(html) {
  return String(html || "").replace(
    /<p class="(?:indicator-benefit|sentence-trends-indicator-benefit)">[\s\S]*?<\/p>/gi,
    "",
  );
}

/**
 * Same layout as DBIndicator; main copy in `statement`, optional extra copy in
 * `logic`. Footer line from `benefit` is rendered centered on its own row
 * below the relevant paragraph (statement or logic), not inline in HTML.
 */
class SentenceTrendsIndicator extends Component {
  renderBenefitRow = (benefitLine, modifierClass) => (
    <div
      className={`sentence-trends-indicator-benefit-row${
        modifierClass ? ` ${modifierClass}` : ""
      }`}
    >
      <p className="sentence-trends-indicator-benefit">— {benefitLine}</p>
    </div>
  );

  render() {
    const {
      statement,
      header,
      logic,
      index,
      benefit,
      showEditButton,
      onEditClick,
      isEdited,
      editDisabled,
    } = this.props;

    const logicTrimmed = logic && String(logic).trim();
    const logicHtml = logicTrimmed ? String(logic) : "";
    const benefitLine = String(benefit ?? "").trim();

    let indicatorExplanationStyles = "";
    let indicatorAdvantageStyles;
    if (logicHtml && logicHtml.length < 60) {
      indicatorAdvantageStyles = "sentence-trends-indicator-advantage-left";
    }

    let headerStyles;
    if (header && header.length >= 33) {
      headerStyles = "sentence-trends-header-more-width";
    } else if (header && header.length >= 39) {
      headerStyles = "sentence-trends-indicator-medium-header";
    }

    const dbBoxStyles = "";
    const statementHtml = stripEmbeddedBenefitParagraph(statement);

    return (
      <div className="sentence-trends-indicator">
        {showEditButton ? (
          <SentenceTrendsEditButton
            label={`Edit Trend #${index}`}
            isEdited={isEdited}
            onClick={onEditClick}
            disabled={editDisabled}
            className="sentence-trends-edit-btn-trend"
          />
        ) : null}
        <p
          className={`sentence-trends-indicator-header-num sentence-trends-header-num-${index}`}
        >
          {index}
        </p>

        <div className="sentence-trends-indicator-surface">
          <div className="sentence-trends-divider" />
          <div
            className={`sentence-trends-box-inner-container sentence-trends-box-inner-${
              index & 1 ? "odd" : "even"
            } ${dbBoxStyles}`}
          >
            <div className="sentence-trends-indicator-header">
              <p
                className={`sentence-trends-indicator-header-category ${headerStyles}`}
              >
                {header}
              </p>
            </div>

            <div
              className={`sentence-trends-indicator-explanation ${indicatorExplanationStyles}`}
              dangerouslySetInnerHTML={{ __html: statementHtml }}
            />
            {benefitLine && !logicTrimmed
              ? this.renderBenefitRow(benefitLine, "")
              : null}
            {logicTrimmed ? (
              <div className="sentence-trends-indicator-advantage-and-benefit-container">
                <div
                  className={`sentence-trends-indicator-advantage ${indicatorAdvantageStyles}`}
                >
                  <div dangerouslySetInnerHTML={{ __html: logicHtml }} />
                </div>
                {benefitLine
                  ? this.renderBenefitRow(
                      benefitLine,
                      "sentence-trends-indicator-benefit-row--after-logic",
                    )
                  : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default SentenceTrendsIndicator;
